import { render, staticRenderFns } from "./detail_ownership.vue?vue&type=template&id=6d2ba00b&scoped=true&"
import script from "./detail_ownership.vue?vue&type=script&lang=js&"
export * from "./detail_ownership.vue?vue&type=script&lang=js&"
import style0 from "./detail_ownership.vue?vue&type=style&index=0&id=6d2ba00b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2ba00b",
  null
  
)

export default component.exports